import { render } from "./FormSubtitle.vue?vue&type=template&id=49bc49ff"
import script from "./FormSubtitle.vue?vue&type=script&lang=js"
export * from "./FormSubtitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__